
export const initChat = (data) => {
    return {type: 'INIT_CHAT', data};
}

export const userJoined = (user) => {
    return {
        type: 'USER_JOINED',
        user
    }
}

export const userLeft = () => {
    return {
        type: 'USER_LEFT'
    }
}

export const newMessage = (message) => {
    return {type: 'NEW_MESSAGE', message};
}

export const sendMessage = (text) => {
    return {type: 'SEND_MESSAGE', text };
}

export const toggleUserList = () => {
    return {
        type: 'TOGGLE_USER_LIST'
    }
}


// WEBPACK FOOTER //
// ./src/actions/chat.js